export const stringify = (value: any) => JSON.stringify(value);
